module.exports = __webpack_public_path__ + "static/media/iss.b79e30f2.png";